import { Centered } from '@prophecy/ui-v3/Layout';
import { Spinner } from '@prophecy/ui-v3/Spinner';
import { toast } from '@prophecy/ui-v3/Toast';
import { usePersistentCallback } from '@prophecy/utils/react/hooks';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { discourseSSO } from '../../data/apis/api';

export default function DiscourseSSO() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const sso = searchParams.get('sso');
  const sig = searchParams.get('sig');

  const handleDiscourseSSO = usePersistentCallback(async () => {
    try {
      const response = (await discourseSSO({
        sso: sso || '',
        sig: sig || ''
      })) as unknown as { success: boolean; redirectUrl: string; message: string };

      if (response.success) {
        // redirect to discourse login page
        window.location.href = decodeURIComponent(response.redirectUrl);
      } else {
        toast.error({ content: response.message, 'data-test-id': 'discourse-sso-error' });
      }
    } catch (error) {
      toast.error({ content: 'Failed to authenticate with Discourse', 'data-test-id': 'discourse-sso-error' });
    }
  });

  useEffect(() => {
    if (!sso || !sig) {
      // redirect to home page, if sso or sig is not present
      navigate('/');
      return;
    }

    handleDiscourseSSO();
  }, [sso, sig, navigate, handleDiscourseSSO]);

  return (
    <Centered>
      <Spinner spinning />
    </Centered>
  );
}
